import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { RequiredProductNames } from '../../../constants/CourseConstants';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRODUCT_TO_INFO_MAP = {
  [RequiredProductNames.crm]: {
    illustrationName: 'crm',
    i18nKeys: {
      header: 'learningCenter.practicalExercise.requiredAccess.crm.header',
      description: 'learningCenter.practicalExercise.requiredAccess.crm.description'
    }
  },
  [RequiredProductNames.marketing]: {
    illustrationName: 'marketing-free',
    i18nKeys: {
      header: 'learningCenter.practicalExercise.requiredAccess.marketing.header',
      description: 'learningCenter.practicalExercise.requiredAccess.marketing.description'
    }
  },
  [RequiredProductNames.sales]: {
    illustrationName: 'sales-free',
    i18nKeys: {
      header: 'learningCenter.practicalExercise.requiredAccess.sales.header',
      description: 'learningCenter.practicalExercise.requiredAccess.sales.description'
    }
  }
};

// @bend-expect trellis-tokenized
const ContentWrapper = styled.div.withConfig({
  displayName: "PracticalExerciseRequiredAccess__ContentWrapper"
})(["background-color:", ";padding:10%;width:100%;height:100%;"], ({
  theme
}) => theme.color['fill-surface-default']);
const PracticalExerciseRequiredAccess = ({
  advanceToNextContent,
  product
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const productInfo = PRODUCT_TO_INFO_MAP[product];
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ContentWrapper, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "100%",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          marginBlockEnd: "400",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: productInfo.i18nKeys.header
          })
        }), /*#__PURE__*/_jsx(Illustration, {
          name: productInfo.illustrationName
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "500",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: productInfo.i18nKeys.description
          })
        })]
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "skip-nonstarted-practical-exercise",
        marginInlineEnd: !isMobile ? '300' : undefined,
        onClick: advanceToNextContent,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.skip"
        })
      })
    })]
  });
};
export default PracticalExerciseRequiredAccess;